import type { FC } from 'react';
import { useRef } from 'react';
import type { SelectProps } from 'components/common';
import { CommonSelect } from 'components/common';
import { UserRole } from 'features/login';

interface AccessLevelOption {
  label: string;
  value: string;
}

interface SelectAccessLevel {
  options?: 'all' | 'short';
  multiples?: boolean;
}

type SelectAccessLevelProps = Partial<
  Pick<
    SelectProps,
    'handleChange' | 'name' | 'inputLabel' | 'placeholder' | 'required' | 'disabled'
  >
> &
  Partial<SelectAccessLevel>;


export const SelectAccessLevel: FC<SelectAccessLevelProps> =
  ({
     handleChange,
     name,
     inputLabel,
     placeholder,
     multiples,
     required,
     disabled,
   }) => {
    const ACCESS_LEVELS = useRef<AccessLevelOption[]>([
      { label: 'Ads posting', value: UserRole.USER },
      { label: 'Ads and Settings', value: UserRole.STAFF },
      { label: 'Superuser', value: UserRole.SUPERUSER },
    ]).current;

    return (
      <CommonSelect
        name={name ?? 'role'}
        inputLabel={inputLabel ?? 'Access level'}
        options={ACCESS_LEVELS}
        handleChange={handleChange}
        placeholder={placeholder ?? 'Value'}
        clearable
        multiples={multiples}
        required={required}
        disabled={disabled}
      />
    );
  };